import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PawPrint } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function TagPage() {
  const { tagId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkTag = async () => {
      try {
        // Check if this tag has been activated
        const response = await axios.get(`${BACKEND_URL}/api/tags/${tagId}/check`);
        
        if (response.data.activated && response.data.pet_id) {
          // Tag is activated - go to pet profile
          navigate(`/pet/${response.data.pet_id}`, { replace: true });
        } else {
          // Tag not activated - go to activation with tag ID
          navigate(`/activate/${tagId}`, { replace: true });
        }
      } catch (error) {
        // Tag doesn't exist or error - go to activation
        navigate(`/activate/${tagId}`, { replace: true });
      }
    };

    if (tagId) {
      checkTag();
    } else {
      navigate('/activate', { replace: true });
    }
  }, [tagId, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center">
        <PawPrint className="w-12 h-12 text-primary animate-pulse mb-4" />
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}
